module.exports = __webpack_public_path__ + "static/12-c2877e1c8380f2e734a02f1de20f4bf2.png";